export default "__VITE_PUBLIC_ASSET__cc01fa08__"